import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(m)/components/auth/webview-http-client';

export interface AddRatingParams {
  order_code: string;
  overall: number;
  tags?: string[];
}

export const submitRatingFn = async (
  token: string,
  params: AddRatingParams,
  config: AxiosRequestConfig = {}
): Promise<any> => {
  const response = await webviewHttpClient.post<any>(
    apiRoutes.ahafood.web_view.add_rating(params.order_code),
    params,
    {
      ...config,
      headers: {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  );

  return response.data;
};

export const useSubmitRating = (
  token: string,
  options?: UseMutationOptions<any, DefaultQueryError, AddRatingParams>
) =>
  useMutation<any, DefaultQueryError, AddRatingParams>({
    mutationFn: (params) => submitRatingFn(token, params),
    ...options,
  });
